import React, { useMemo } from 'react';
import { ResponsiveBar } from '@nivo/bar';

const FALLBACK_COLORS = {
  completed: '#2B6CB0',
  upcoming: '#BEE3F8',
  prior: '#94A3B8',
};

const PriorPeriodLayer = ({ data, xScale, yScale, color }) => {
  const points = data.map((item) => ({
    x: xScale(item.label) + xScale.bandwidth() / 2,
    y: yScale(item.prior),
  }));

  if (!points.length) {
    return null;
  }

  const path = points.map((point, index) => `${index ? 'L' : 'M'} ${point.x} ${point.y}`).join(' ');
  return (
    <g className="status-report-trend__prior">
      <path d={path} fill="none" stroke={color} strokeWidth="2" strokeDasharray="6 5" />
      {points.map((point, index) => (
        <circle key={data[index].label} cx={point.x} cy={point.y} r="3" fill={color} />
      ))}
    </g>
  );
};

const StatusTrendChart = ({ data = [], palette = {} }) => {
  const chartData = useMemo(() => data.map((item) => ({ ...item })), [data]);
  const colors = {
    completed: palette.chartCurrent || FALLBACK_COLORS.completed,
    upcoming: palette.chartUpcoming || FALLBACK_COLORS.upcoming,
    prior: palette.chartPrior || FALLBACK_COLORS.prior,
  };

  if (!chartData.length) {
    return <div className="status-report-empty">No activity in this period.</div>;
  }

  return (
    <div className="status-report-trend">
      <div className="status-report-trend__canvas">
        <ResponsiveBar
          data={chartData}
          keys={['completed', 'upcoming']}
          indexBy="label"
          margin={{ top: 12, right: 18, bottom: 42, left: 38 }}
          padding={0.42}
          groupMode="stacked"
          colors={({ id }) => colors[id]}
          borderWidth={1}
          borderColor={palette.chartBorder || colors.completed}
          enableLabel={false}
          enableGridX={false}
          borderRadius={2}
          axisLeft={{ tickSize: 0, tickPadding: 8, format: (value) => Number.isInteger(value) ? value : '' }}
          axisBottom={{ tickSize: 0, tickPadding: 10 }}
          animate={false}
          theme={{
            fontFamily: 'Inter, Montserrat, sans-serif',
            textColor: 'var(--app-text-muted)',
            axis: { ticks: { text: { fill: 'var(--app-text-muted)' } } },
            grid: { line: { stroke: 'var(--app-border)' } },
            tooltip: {
              container: {
                background: 'var(--app-surface)',
                color: 'var(--app-text)',
                border: '1px solid var(--app-border)',
              },
            },
          }}
          layers={[
            'grid',
            'axes',
            'bars',
            (props) => <PriorPeriodLayer {...props} data={chartData} color={colors.prior} />,
            'markers',
            'legends',
          ]}
        />
      </div>
      <div className="status-report-legend">
        <span><i style={{ background: colors.completed }} />Completed</span>
        <span><i style={{ background: colors.upcoming }} />Upcoming booked</span>
        <span><i className="status-report-legend__line" style={{ borderColor: colors.prior }} />Prior period</span>
      </div>
    </div>
  );
};

export default StatusTrendChart;
